{
  "id": 3,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 10,
  "kinds": 4,
  "goals": [
    { "type": "collect", "kind": "latte", "count": 44 },
    { "type": "collect", "kind": "macaron", "count": 44 }
  ],
  "stars": [10130, 14830],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 1, "movesLeft": 6.4, "closeLosses": 0, "target": 0.99 }
}
